app.controller('teacherAppGroupStatusCtrl', [
    '$scope', '$interval', 'gameService', 'teacherAppService', '$state', '$stateParams', '$window', '$timeout', function ($scope, $interval, gameService, teacherAppService, $state, $stateParams, $window, $timeout) {
    	var vm = this;

    	vm.gameService = gameService;
        vm.teacherAppService = teacherAppService;

		vm.gameInverseProgressStyle = [];
		vm.gameProgress = [];

        function countGameStateProgress(gameState) {
			var count = 0;
	        for (var i = 0; i < gameService.exercises.length; i++) {
	        	if (i == gameState.exerciseIndex) {
		    		count += gameState.questionIndex;
		    		count += gameState.evaluationQuestionIndex;
		    		return count;
	        	}
				var exercise = gameService.exercises[i];
				count += exercise.questions.length;
				count += exercise.evaluationQuestions.length;
	        }
	        return count;
        }

        vm.showDetails = function(idx) {
			vm.teacherAppService.setCurrentGroup(idx);
			$state.go('teacherapp.groupstatus.details', {id: idx});
        }

        vm.updateStateFromTeacherAppService = function() {
			if (!teacherAppService.isReady()) {
				return;
			}

       		var totalItems = 0;
	        for (var i = 0; i < gameService.exercises.length; i++) {
	        	var exercise = gameService.exercises[i];
	        	totalItems += exercise.questions.length;
	        	totalItems += exercise.evaluationQuestions.length;
	        }

	        vm.gameInverseProgressStyle = [];
	        vm.gameProgress = [];
	        var gameInfo = vm.teacherAppService.gameInfo;
	        for (var i = 0; i < gameInfo.length; i++) {
	        	var gi = gameInfo[i];
	        	var gameState = gi.gameState;
				var progress = countGameStateProgress(gameState);
				var pct = progress / totalItems;
				vm.gameInverseProgressStyle.push({"width": (100 - parseInt(pct * 100)) + "%"});
				vm.gameProgress.push(parseInt(pct * 100));
	        }
        }

        $scope.$on('teacherAppServiceUpdated', function() {
        	vm.updateStateFromTeacherAppService();
        });

        vm.updateStateFromTeacherAppService();
    }
]);